<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div
    class="lgrm-emoji "
    :style="bodyStyle"
    @click="$emit('click')"
    :class="{ 'lgrm-selected': selected, 'lgrm-read-only': readonly, 'lgrm-embed': embed}"
    ref="emoji"
  >
    
    <svg
      class="lgrm-emoji-svg"
      :style="svgStyle"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <ellipse
        class="lgrm-transparent-bg"
        cx="200"
        cy="200"
        rx="174.02"
        ry="173.71"
        :style="emojiBgStyle"
      />
      <ellipse
        cx="266.54"
        cy="148.1"
        rx="29.69"
        ry="29.68"
        transform="translate(-0.45 0.82) rotate(-0.18)"
        :style="emojiOrganStyle"
      />
      <ellipse
        cx="134.49"
        cy="148.1"
        rx="29.69"
        ry="29.68"
        transform="translate(-0.23 0.21) rotate(-0.09)"
        :style="emojiOrganStyle"
      />
      <path
        v-if="rating === 1"
        d="M270.33,290.74a73.72,73.72,0,0,0-144.76,0,11.79,11.79,0,0,0,11.59,14H258.75A11.78,11.78,0,0,0,270.33,290.74Z"
        :style="emojiOrganStyle"
      />
      <path
        v-if="rating === 2"
        d="M142.44,303.71a10.24,10.24,0,0,1-7.7-17,87.19,87.19,0,0,1,131.26,0,10.24,10.24,0,0,1-15.4,13.49,66.71,66.71,0,0,0-100.46,0A10.19,10.19,0,0,1,142.44,303.71Z"
        :style="emojiOrganStyle"
      />
      <rect
        v-if="rating === 3"
        x="132.21"
        y="256.94"
        width="136.33"
        height="20.01"
        rx="10.01"
        ry="10.01"
        :style="emojiOrganStyle"
      />
      <path
        v-if="rating === 4"
        d="M200.37,303.71a87.29,87.29,0,0,1-65.63-29.79,10.24,10.24,0,1,1,15.4-13.49,66.71,66.71,0,0,0,100.46,0A10.24,10.24,0,1,1,266,273.92,87.29,87.29,0,0,1,200.37,303.71Z"
        :style="emojiOrganStyle"
      />
      <path
        v-if="rating === 5"
        d="M258.75,231H137.16a11.79,11.79,0,0,0-11.59,14,73.72,73.72,0,0,0,144.76,0A11.78,11.78,0,0,0,258.75,231Z"
        :style="emojiOrganStyle"
      />
      <path
        d="M200,36.52A163.48,163.48,0,1,1,84.18,315.58,163.48,163.48,0,0,1,200,36.52m0-20.47C98.24,16.05,15.75,98.41,15.75,200S98.24,384,200,384,384.25,301.59,384.25,200,301.76,16.05,200,16.05Z"
        :style="emojiBorderStyle"
      />
    </svg>
    <div class="lgrm-emoji-label" v-if="label" :style="labelStyle">{{ label }}</div>
    <div class="lgrm-emoji-tooltip" v-if="!disableToolTip" >
      <div class='lgrm-emoji-tooltip-content' :style="tooltipContentStyle">{{ label }}</div>
      <div class="lgrm-arrow" :style='tooltipArrowStyle'></div>
    </div>
  </div>
</template>

<script>
import DynamicStyle from '../DynamicStyle'
import colorMixin from '../../../../../src/mixins/colors'
export default {
  name: 'Emoji',
  mixins: [colorMixin],
  components: { DynamicStyle },
  props: {
    rating: {
      type: Number
    },
    selected: {
      type: Boolean,
      default: false
    },
    color: { type: String, default: '#132968' },
    borderColor: { type: String },
    organColor: { type: String },
    bgColor: { type: String },
    bgColorSelected: { type: String },
    label: String,
    size: { type: Number, default: 40 },
    readonly: {
      type: Boolean,
      default: false
    },
    bodyStyle: {
      type: Object
    },
    disableToolTip: {
      type: Boolean,
      default: true
    },
    embed: {
      type: Boolean,
      default: false
    },
    labelStyle: Object
  },
  mounted(){
    
  },
  data(){
    return {
      show: false
    }
  },
  computed: {
    svgStyle() {
      const stl = {}
      stl.width = this.size + 'px'
      stl.height = this.size + 'px'
      return stl
    },
    emojiBorderStyle() {
      const stl = {}
      if (this.selected) {
        stl['fill'] = this.color
      } else {
        stl['fill'] = this.borderColor || this.color
      }
      return stl
    },
    emojiOrganStyle() {
      const stl = {}
      if (this.selected) {
        stl['fill'] = '#fff'
      } else {
        stl['fill'] = this.organColor || this.color
      }
      return stl
    },
    emojiBgStyle() {
      const stl = {}
      stl['fill'] = this.bgColor || this.color
      if (this.selected) {
        stl.opacity = 1
      } else {
        if (this.bgColor) {
          stl.opacity = 1
        } else stl.opacity = 0.05
      }

      return stl
    },
    tooltipContentStyle (){
      var textColor = '#fff'
       if (this.isColorLighter(this.color)) {
          textColor = '#000'
        } 
      return {
        'background-color': this.color,
        'color': textColor
      }
    },
    tooltipArrowStyle (){
      return {
        'border-color': `transparent transparent ${ this.color }  transparent`
      }
    },
  },
  methods: {
    select() {
      if (this.readonly) return
      this.$emit('change', true)
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-emoji {
    display inline-block
    position relative
    width 50px
    padding 0 4px
    text-align center
    vertical-align top
    &.lgrm-embed {
      .lgrm-emoji-label {
        display: block
      }
    }
    &:hover {
      .lgrm-emoji-tooltip {
        display  block
      }
    }
    .lgrm-emoji-svg {
        display inline-block
    }
    &:not(.lgrm-read-only) {
        cursor pointer
    }
    .lgrm-emoji-fill {
        display none
    }
    &:hover, &.lgrm-selected {
        .lgrm-emoji-normal {
            display none
        }
        .lgrm-emoji-fill {
            display inline-block
        }
    }
    .lgrm-emoji-label {
        width 100px
        text-align center
        font-size 11px
        display none
        position relative
        margin-left -30px
        color #666666
        padding 3px 10px
        border-radius 5px
        
    }
    .lgrm-emoji-tooltip {
      margin-left  -102px
      display  none
      width 250px
      color #fff
      text-align center
      position relative
      z-index 1
      text-align center
      .lgrm-arrow {
        position absolute
        top -6px
        left 50%
        margin-left -5px
        border-bottom-width 5px
        border-style solid
      }
      .lgrm-emoji-tooltip-content {
        height 100%
        padding 4px 10px
        border-radius 5px
        display inline
        font-size 11px
      }
    }
    &.lgrm-first, &.lgrm-last {
      .lgrm-emoji-label {
        display block
      }
    }
    @media (max-width 400px)
    {
        width 45px
        
    }


  
}
</style>
